import { QualarooLoaderDocumentQuery } from '../../../types/__generated__';
import { daysToEvent } from '../../utils/daysToEvent';
import { firstArrayItem } from '../../utils/firstArrayItem';
import { filterByTypename } from '../../utils/graphql';
import { numberToString } from '../../utils/numberToString';
import { onlyImages } from '../../utils/typeGuards';
import { daysFromEvent } from '../../utils/daysFromEvent';

export function mapToQualarooCustomProperties(
  data: QualarooLoaderDocumentQuery['page'],
) {
  const target = data?.targetWithCurrency?.value;
  const totalAmount = data?.donationSummary?.totalAmount?.value;
  const percentageRaised =
    target && (totalAmount || totalAmount === 0)
      ? ((totalAmount / target) * 100).toString()
      : undefined;

  const charity = data?.relationships?.beneficiaries.nodes
    ? firstArrayItem(
        filterByTypename(data?.relationships?.beneficiaries.nodes, 'Charity'),
      )
    : undefined;
  const campaign = firstArrayItem(data?.relationships?.campaigns.nodes);
  const team = firstArrayItem(data?.relationships?.teams.nodes);
  const event = firstArrayItem(data?.relationships?.events.nodes);
  const donation = firstArrayItem(data?.donations?.nodes);

  return {
    pageStatus: data?.status,
    createdDate: data?.createDate,
    createdDays: daysFromEvent(data?.createDate),
    raisedAmount: totalAmount?.toString(),
    charityGUID: charity?.legacyId,
    currency: data?.currency,
    targetAmount: numberToString(target),
    campaignGUID: campaign?.legacyId,
    percentageRaised,
    teamGUID: team?.legacyId,
    eventId: event?.legacyId,
    eventName: event?.title,
    eventDate: event?.startDate,
    timeToEvent: daysToEvent(event?.startDate),
    daysToPageCloses: daysToEvent(data?.endDate),
    daysFirstDonation: daysToEvent(donation?.creationDate),
    teamConnected: team ? 'true' : 'false',
    campaignConnected: campaign ? 'true' : 'false',
    offlineDonation: numberToString(
      data?.donationSummary?.offlineAmount?.value,
    ),
    profilePhoto: data?.owner?.avatar,
    coverPhoto: data?.heroMedia && onlyImages(data.heroMedia),
    supporterCount: numberToString(data?.donationSummary?.donationCount),
    updatesCount: numberToString(data?.timeline?.totalCount),
    imageCount: numberToString(data?.mediaCollection?.totalCount),
  };
}
